/**
 * Window events the sidebar listens for, so a write elsewhere can tell it a list it draws has
 * moved — the upload dock's `repository:uploaded` pattern. Here in `lib/` because the features
 * fire them and `layouts/` hears them, and neither may import the other.
 */

/** An attrition category was created, renamed, deleted, restored or cleared — the rail lists them. */
export const ATTRITION_CATEGORIES_CHANGED = 'attrition:categories-changed';

/** Tell the sidebar the category list moved. Call after any write that changes it. */
export function announceAttritionCategoriesChanged() {
  window.dispatchEvent(new Event(ATTRITION_CATEGORIES_CHANGED));
}
